import { mapParamsBySchema } from '../../../../../util';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';
import Global from '../../../../../Services/Common/Global';
import { QRDialog_Schema } from './QRDialog_Schema';
import useDeleteMutation from '../../../../../Hooks/apis/useDeleteMutaion';

/** TBM 정보 삭제 DeleteTbmNewD1 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (item) => {
    const payload = mapParamsBySchema(QRDialog_Schema.mapper.delete1, item);
    return apiRequest('post', Global.urls.ToolBoxMeeting.deleteTbmNewD1, [payload]);
  }, options);
};

/** TBM 참가자 삭제 DeleteTbmNewD4 */
export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (item) => {
    const { sessionCd, targetUserIds } = item;
    const payload = targetUserIds.map((targetUserId) =>
      mapParamsBySchema(QRDialog_Schema.mapper.delete2, {
        sessionCd,
        targetUserId,
      })
    );
    return apiRequest(
      'post',
      Global.urls.ToolBoxMeeting.deleteTbmNewD4,
      payload
    );
  }, options);
};